import React from 'react';
import { Clock } from 'lucide-react';

export const ComingSoon: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-center max-w-xl">
        <div className="mx-auto mb-6 h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
          <Clock className="h-7 w-7 text-slate-500" />
        </div>
        <h1 className="text-2xl font-semibold text-slate-800">Coming soon</h1>
        <p className="mt-3 text-slate-600">
          We’re building this page now. Check back shortly for updates. If you
          have feedback or need something prioritized, please reach out to your
          Reach contact.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
